import { render, staticRenderFns } from "./06_ap_destinos_mercancias.vue?vue&type=template&id=08026ec6&scoped=true&"
import script from "./06_ap_destinos_mercancias.vue?vue&type=script&lang=js&"
export * from "./06_ap_destinos_mercancias.vue?vue&type=script&lang=js&"
import style0 from "./06_ap_destinos_mercancias.vue?vue&type=style&index=0&id=08026ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08026ec6",
  null
  
)

export default component.exports